export const googleCaptcha = (sitekey, isLoaded) => {
  let loaded = isLoaded;

  let challengeCallback = null;

  const onSubmit = (token) => {
    if (challengeCallback) {
      challengeCallback(token);
    }
  };

  const initiate = (node) => {
    window.grecaptcha.render(node, {
      sitekey,
      callback: onSubmit,
      size: 'invisible',
    });

    window.grecaptcha.reset();
    window.grecaptcha.execute();
  };

  const show = () => {
    window.grecaptcha.reset();
    window.grecaptcha.execute();
  };

  const loadAndShow = (node) => {
    window.captchaOnLoadCallback = () => {
      loaded = true;
      initiate(node);
    };
    $.getScript('https://www.google.com/recaptcha/api.js?onload=captchaOnLoadCallback&render=explicit');
  };

  const challenge = (node, callback) => {
    challengeCallback = callback;

    if (!loaded) {
      loadAndShow(node);
      return;
    }

    show(node);
  };

  return {
    challenge,
  };
};
